import type { JSX } from 'react';

/** What a browser tab cannot do compared with a native production tool. Shown in About and Settings. */
export function Limitations(): JSX.Element {
  return (
    <div className="prose">
      <p>Everything runs inside this browser tab: capture, compositing, mixing, encoding and recording. That brings some limits.</p>
      <ul>
        <li>
          <strong>No RTMP from the browser.</strong> Streaming goes peer-to-peer over WebRTC, or to a WHIP endpoint. Platforms that only
          accept RTMP need a server-side bridge.
        </li>
        <li>
          <strong>Screen and window capture need a click each time.</strong> The browser asks which screen to share on every start and
          cannot restore it after a reload.
        </li>
        <li>
          <strong>No capture of individual applications' audio</strong> beyond what the screen-share picker offers (tab audio, and system
          audio on some platforms).
        </li>
        <li>
          <strong>Recording formats are whatever this browser's MediaRecorder supports</strong>; bitrate is a target, not a guarantee.
        </li>
        <li>
          <strong>Peer-to-peer streaming scales to a handful of viewers.</strong> Every viewer costs one more encode and upload; use WHIP
          to an SFU for an audience.
        </li>
        <li>
          <strong>Audio sync offsets can only delay audio</strong>, never video.
        </li>
        <li>
          <strong>Keyboard shortcuts work only while this tab has focus</strong>, and some combinations belong to the browser.
        </li>
        <li>
          <strong>Background tabs are throttled.</strong> Keep the studio in its own visible window while live.
        </li>
        <li>
          <strong>Plugins run with full access to this page.</strong> Load only code you trust.
        </li>
        <li>
          <strong>Projects, assets and recordings live in this browser's storage</strong> for this site. Clearing site data deletes them;
          export what matters.
        </li>
      </ul>
    </div>
  );
}
